import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {error, newItemSuccess, updateItemSuccess} from '@/utils/notification';

import {
  ADD_ACADEMICPERIODCONFIG,
  GET_ACADEMICPERIODCONFIGS,
  GET_ACADEMICPERIODCONFIGS_CURRENT,
  GET_ACADEMICPERIODCONFIG,
  UPDATE_ACADEMICPERIODCONFIG,
} from '@/queries/modules/common-data/academicPeriodConfig';

//
// initial state
const state = {
  academicPeriodConfig: {
    id: '',
    applyPeriod: '',
    applyPeriodCode: '',
    learnPeriod: '',
    learnPeriodCode: '',
    enrollPeriod: '',
    enrollPeriodCode: '',
  },
  academicPeriodConfigs: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setAcademicPeriodConfigs: (state, payload) => {
    state.academicPeriodConfigs = payload ? payload : [];
  },
  setAcademicPeriodConfig: (state, payload) => {
    state.academicPeriodConfig = payload;
  },
  setSelectedAcademicPeriodConfig: (state, payload) => {
    state.academicPeriodConfig = {...payload};
  },
  clearSelectedAcademicPeriodConfig: (state) => {
    state.academicPeriodConfig = {
      id: '',
      applyPeriod: '',
      applyPeriodCode: '',
      learnPeriod: '',
      learnPeriodCode: '',
      enrollPeriod: '',
      enrollPeriodCode: '',
    }
  }
};

//
// actions
const actions = {
  getAcademicPeriodConfigs: async ({commit}) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_ACADEMICPERIODCONFIGS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setAcademicPeriodConfigs', data.getAcademicPeriodConfigs);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getAcademicPeriodConfig: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_ACADEMICPERIODCONFIG,
        variables: {
          id: id
        },
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setAcademicPeriodConfig', data.getAcademicPeriodConfig);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getCurrentAcademicPeriodConfig: async ({commit}, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_ACADEMICPERIODCONFIGS_CURRENT,
          context: { clientName: 'Prisma2' }
        });

      const {data, errors} = await result;
      if (errors) {
        commit('setError', error(errors));
        return state.academicPeriodConfig;
      } else {
        if (useState) {
          commit('setAcademicPeriodConfig', data.getCurrentAcademicPeriodConfig);
        }
        commit('setSuccess', null);
        return data.getCurrentAcademicPeriodConfig
      }

    } catch (e) {
      commit('setError', error(e));
      return state.academicPeriodConfig;
    }
  },
  addAcademicPeriodConfig: async ({commit}, payload) => {
    commit('setProcessing', true);
    await apolloClient
      .mutate({
        mutation: ADD_ACADEMICPERIODCONFIG,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const academicPeriodConfigs = [...state.academicPeriodConfigs];
        academicPeriodConfigs.push(data.addAcademicPeriodConfig);
        commit('setAcademicPeriodConfigs', academicPeriodConfigs);
        commit('setSuccess', newItemSuccess(data.addAcademicPeriodConfig.learnPeriodCode));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },
  updateAcademicPeriodConfig: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_ACADEMICPERIODCONFIG,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.academicPeriodConfigs.findIndex(academicPeriodConfig => academicPeriodConfig.id === data.updateAcademicPeriodConfig.id);
        const academicPeriodConfigs = [
          ...state.academicPeriodConfigs.slice(0, index),
          data.updateAcademicPeriodConfig,
          ...state.academicPeriodConfigs.slice(index + 1)
        ];

        commit('setAcademicPeriodConfigs', academicPeriodConfigs);
        commit('setSuccess', updateItemSuccess(data.updateAcademicPeriodConfig.learnPeriodCode));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedAcademicPeriodConfig: async ({commit}, payload) => {
    commit('setSelectedAcademicPeriodConfig', payload);
  },
  clearSelectedAcademicPeriodConfig: async ({commit}) => {
    commit('clearSelectedAcademicPeriodConfig');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
